import template from './list-articles.html';
import controller from './list-articles.controller';
import './list-articles.scss';

let ListArticlesComponent = {
  bindings: {
    articlesObservable: '<'
  },
  template,
  controller
};

export default ListArticlesComponent;



// WEBPACK FOOTER //
// ./src/app/pages/list-articles/list-articles.component.js